export default __webpack_public_path__ + "static/header-fe8fba07fb50a77e5159c4ffb03fba6e.jpg";